import { useQuery } from '@tanstack/react-query';

import { api } from '../config/api';
import type { TestUser } from '../types/api';

/**
 * GET /carousel/test-users → fixture test users.
 *
 * Pass `country` to filter to a country tab (ISO 3166-1 alpha-2 like 'SE').
 * `'global'` / null → all users (no filter). Undefined → legacy v1: all.
 */
export function useTestUsers(country?: string | null) {
  return useQuery({
    queryKey: ['test-users', country ?? 'all'],
    queryFn: () => {
      const path =
        country && country !== 'global'
          ? `/carousel/test-users?country=${encodeURIComponent(country)}`
          : '/carousel/test-users';
      return api<TestUser[]>(path);
    },
    staleTime: 10 * 60 * 1000,
  });
}
